import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PortalService } from './portal.service';
import { Observable } from 'rxjs';
import { User } from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  me(): Observable<any> {
    return this.http.get<User>(PortalService.ApiUrl + '/user/me');
  }
}
